import axios from "axios";

let BASE_URL = process.env.REACT_APP_API_BASE_URL;

if (!BASE_URL) {
  const isBrowser = typeof window !== "undefined" && window.location;

  if (isBrowser && window.location.hostname === "localhost") {
    BASE_URL = "http://localhost:8000/api";
  } else if (isBrowser && window.location.hostname.startsWith("10.")) {
    // Adjust this logic if your local LAN IP is different
    BASE_URL = `http://${window.location.hostname}:8000/api`;
  } else {
    // Fallback (optional, could throw an error or use default)
    BASE_URL = "http://10.0.0.9:8000/api"; // fallback LAN IP
  }
}

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// 🔐 Attach latest access token before each request
api.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem("access") || sessionStorage.getItem("access");
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

// 🔁 Handle expired tokens globally and auto-refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const is401 = error.response?.status === 401;
    const refreshToken =
      localStorage.getItem("refresh") || sessionStorage.getItem("refresh");

    if (is401 && !originalRequest._retry && refreshToken) {
      originalRequest._retry = true;

      try {
        const res = await axios.post(`${BASE_URL}/auth/jwt/refresh/`, {
          refresh: refreshToken,
        });

        const newAccess = res.data.access;

        if (localStorage.getItem("refresh")) {
          localStorage.setItem("access", newAccess);
        } else {
          sessionStorage.setItem("access", newAccess);
        }

        // Update the token in both default and current request headers
        api.defaults.headers.common["Authorization"] = `Bearer ${newAccess}`;
        originalRequest.headers.Authorization = `Bearer ${newAccess}`;

        return api(originalRequest);
      } catch (refreshErr) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/login"; // 🔐 Auto-logout and redirect
        return Promise.reject(refreshErr);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
